import * as fromDatatype from '../datatype-library/index';

export interface bl_pos_terminal_device_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  model: fromDatatype.VarcharDatatypeInterface;
  brand: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  browser_name: fromDatatype.VarcharDatatypeInterface;
  browser_version: fromDatatype.VarcharDatatypeInterface;
  operating_system: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rendering_engine: fromDatatype.VarcharDatatypeInterface;
  rendering_engine_version: fromDatatype.VarcharDatatypeInterface;
  mac_address: fromDatatype.VarcharDatatypeInterface;
}

export class bl_pos_terminal_device_RowClass implements bl_pos_terminal_device_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  model: fromDatatype.VarcharDatatypeInterface;
  brand: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  browser_name: fromDatatype.VarcharDatatypeInterface;
  browser_version: fromDatatype.VarcharDatatypeInterface;
  operating_system: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rendering_engine: fromDatatype.VarcharDatatypeInterface;
  rendering_engine_version: fromDatatype.VarcharDatatypeInterface;
  mac_address: fromDatatype.VarcharDatatypeInterface;
}
